(function () {
  // Debug: window.__STOCK_BADGE_DEBUG__ = true
  window.__STOCK_BADGE_VERSION = "v3-targeted-rules-inline-stock-sticky";
  function log(){try{ if(window.__STOCK_BADGE_DEBUG__) console.debug.apply(console, arguments);}catch(e){}}
  function onReady(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  // === CONFIG ===
  var TARGET_HANDLES = ['littlebig-convertible-balance-bike']; // special product(s)
  var LOW_STOCK_THRESHOLD = 1;   // only used for non-target products
  var PREORDER_NOTE = '';        // optional text after the pill for preorder

  var PRICE_SELECTORS = [
    '.product-price__current-price',
    '.product-price__cost',
    '.product-price__content',
    '.product-price',
    '.product__price .money',
    '.product__price [data-money]',
    '[data-product-price] .money',
    '[data-product-price]',
    '.product__price',
    '.product-price__current',
    '.price__current',
    '.price .money',
    '.price'
  ];

  // --- DOM helpers ---
  function root(){ var f=document.querySelector('form[action^="/cart/add"]'); return (f && f.closest('[id^="shopify-section"]')) || document; }
  function form(r){ return r.querySelector('form[action^="/cart/add"]'); }
  function findPriceAnchor(r){
    for (var i=0;i<PRICE_SELECTORS.length;i++){ var el=r.querySelector(PRICE_SELECTORS[i]); if (el) return el; }
    return null;
  }
  function ensureInlineWrap(anchor){
    var parent = anchor.parentNode || anchor;
    if (parent.classList) parent.classList.add('price-and-stock--inline');
    return parent;
  }
  function ensureBadge(anchor){
    var parent = ensureInlineWrap(anchor);
    var badge = parent.querySelector('[data-stock-badge]');
    if (!badge){
      badge = document.createElement('span');
      badge.setAttribute('data-stock-badge','');
      if (anchor.nextSibling) parent.insertBefore(badge, anchor.nextSibling); else parent.appendChild(badge);
    }
    return badge;
  }
  function setPreorderNote(badge, text){
    var parent = badge && badge.parentNode; if (!parent) return;
    var old = parent.querySelector('.price-preorder-note'); if (old) old.remove();
    if (text){
      var span = document.createElement('span');
      span.className = 'price-preorder-note';
      span.textContent = text;
      parent.insertBefore(span, badge.nextSibling);
    }
  }

  // --- Data helpers ---
  function handleFromUrl(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function tryReadProductJsonFromDom(){
    var el = document.getElementById('ProductJson')
      || document.querySelector('[id^="ProductJson-"]')
      || document.querySelector('script[type="application/json"][data-product-json]')
      || document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || el.innerHTML || el.dataset.product); }
    catch(e){ return null; }
  }

  function tryReadInlineStock(){
    var el = document.getElementById('StockBadgeData');
    if (!el) return null;
    try { return JSON.parse(el.textContent || el.innerHTML); }
    catch(e){ return null; }
  }

  async function fetchProductJson(){
    var handle = handleFromUrl();
    if (!handle) return null;
    try {
      var res = await fetch('/products/' + handle + '.js', { credentials:'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch(e){ return null; }
  }

  // Merge inline StockBadgeData (qty/policy) into product variants
  function mergeInlineStock(product){
    var inline = tryReadInlineStock();
    if (!inline || !inline.variants || !product || !product.variants) return product;
    var map = Object.create(null);
    inline.variants.forEach(function(iv){ map[iv.id] = iv; });
    product.variants = product.variants.map(function(v){
      var iv = map[v.id] || {};
      if (typeof v.inventory_quantity === 'undefined') v.inventory_quantity = (typeof iv.inventory_quantity === 'number') ? iv.inventory_quantity : null;
      if (typeof v.inventory_policy   === 'undefined') v.inventory_policy   = iv.inventory_policy;
      if (typeof v.available          === 'undefined') v.available          = iv.available;
      return v;
    });
    if (!product.handle && inline.handle) product.handle = inline.handle;
    return product;
  }

  async function getProductData(){
    var p = tryReadProductJsonFromDom();
    if (p) return mergeInlineStock(p);
    p = await fetchProductJson();
    if (p) return mergeInlineStock(p);
    var inline = tryReadInlineStock();
    if (inline){
      return {
        handle: inline.handle || handleFromUrl() || '',
        variants: (inline.variants || []).map(function(iv){ return {
          id: iv.id,
          inventory_quantity: typeof iv.inventory_quantity === 'number' ? iv.inventory_quantity : null,
          inventory_policy: iv.inventory_policy,
          available: iv.available
        };})
      };
    }
    return null;
  }

  function isTargetProduct(product){
    var h = (product && product.handle || '').toLowerCase();
    return TARGET_HANDLES.indexOf(h) !== -1;
  }

  function currentVariant(r, product){
    if (!product || !product.variants) return null;
    var f = form(r);
    var idEl = f && (f.querySelector('input[name="id"]') || f.querySelector('select[name="id"]'));
    var vid = idEl ? parseInt(idEl.value, 10) : null;
    if (vid){
      for (var i=0;i<product.variants.length;i++){ if (product.variants[i].id === vid) return product.variants[i]; }
    }
    return product.variants[0] || null;
  }

  // === classification per your rules (using qty + policy) ===
  function stateFor(product, variant){
    var qty    = (variant && typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : null;
    var policy = (variant && variant.inventory_policy) || null;
    var avail  = !!(variant && variant.available);

    if (isTargetProduct(product)) {
      if (qty !== null) {
        if (qty <= 0) {
          if (policy === 'continue') return { cls:'preorder', text:'Pre Order-Ships Late November', note: PREORDER_NOTE };
          return { cls:'out', text:'Sold Out Until 2026', note: null };
        }
        return { cls:'in', text:'In Stock-Delivered in 2-4 Days', note: null };
      }
      if (!avail && policy === 'continue') return { cls:'preorder', text:'Pre Order', note: PREORDER_NOTE };
      if (!avail) return { cls:'out', text:'Sold Out Until 2026', note: null };
      return { cls:'in', text:'In Stock', note: null };
    }

    // Non-target products
    if (qty !== null) {
      if (qty > 0) {
        if (qty <= LOW_STOCK_THRESHOLD) return { cls:'low', text:'Low stock', note: null };
        return { cls:'in', text:'In Stock', note: null };
      }
      return { cls:'out', text:'Sold Out', note: null };
    }
    return avail ? { cls:'in', text:'In Stock', note: null } : { cls:'out', text:'Sold Out', note: null };
  }

  function paint(r, product, variant){
    var anchor = findPriceAnchor(r); if (!anchor) return;
    var s = stateFor(product, variant);
    var badge = ensureBadge(anchor);
    badge.className = 'price-badge price-badge--' + s.cls;
    badge.textContent = s.text;
    setPreorderNote(badge, s.note);
  }

  // === Sticky wiring (handles repeated DOM swaps) ===
  function bindVariantIdWatcher(r, product){
    var f = form(r); if (!f) return;
    var idEl = f.querySelector('input[name="id"], select[name="id"]');
    if (!idEl) return;
    if (r.__idWatcher && r.__idWatcher.el === idEl) return; // already watching this instance

    if (r.__idWatcher && r.__idWatcher.mo){ try{ r.__idWatcher.mo.disconnect(); }catch(e){} }
    var lastVal = idEl.value;
    var rebake = function(){
      if (idEl.value !== lastVal){
        lastVal = idEl.value;
        var v = currentVariant(r, product);
        r.__lastVariant = v;
        paint(r, product, v);
      }
    };
    var mo = new MutationObserver(rebake);
    mo.observe(idEl, { attributes:true, attributeFilter:['value'] });
    idEl.addEventListener('input', rebake, {passive:true});
    idEl.addEventListener('change', rebake, {passive:true});
    r.__idWatcher = { el:idEl, mo:mo };
  }

  function bindPriceWatcher(r, product){
    var a = findPriceAnchor(r); if (!a) return;
    var container = a.parentNode || r;
    if (r.__priceMo){ try{ r.__priceMo.disconnect(); }catch(e){} }
    var scheduled = false;
    var mo = new MutationObserver(function(){
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function(){
        scheduled = false;
        var v = r.__lastVariant || currentVariant(r, product);
        paint(r, product, v);
        bindVariantIdWatcher(r, product); // in case input was replaced
      });
    });
    mo.observe(container, { childList:true, subtree:true });
    r.__priceMo = mo;
  }

  // Observe the entire section root for any swaps and rebind everything (debounced)
  function bindRootWatcher(r, product){
    if (r.__rootMo){ try{ r.__rootMo.disconnect(); }catch(e){} }
    var tick = null;
    var mo = new MutationObserver(function(){
      if (tick) cancelAnimationFrame(tick);
      tick = requestAnimationFrame(function(){
        var v = r.__lastVariant || currentVariant(r, product);
        paint(r, product, v);
        bindVariantIdWatcher(r, product);
        bindPriceWatcher(r, product);
      });
    });
    mo.observe(r, { childList:true, subtree:true });
    r.__rootMo = mo;
  }

  async function init(){
    var r = root(); if (!r) return;
    var product = await getProductData(); if (!product) return;

    var v = currentVariant(r, product);
    r.__lastVariant = v;
    paint(r, product, v);

    bindVariantIdWatcher(r, product);
    bindPriceWatcher(r, product);
    bindRootWatcher(r, product);

    // Theme events (when provided)
    document.addEventListener('variant:change', function(e){
      var vv = (e.detail && e.detail.variant) ? e.detail.variant : currentVariant(r, product);
      r.__lastVariant = vv; paint(r, product, vv);
    });
    document.addEventListener('variant:changed', function(e){
      var vv = (e.detail && e.detail.variant) ? e.detail.variant : currentVariant(r, product);
      r.__lastVariant = vv; paint(r, product, vv);
    });

    // Form change fallback
    var f = form(r);
    if (f){
      f.addEventListener('change', function(){
        var vv = currentVariant(r, product);
        r.__lastVariant = vv; paint(r, product, vv);
      }, {passive:true});
    }
  }

  onReady(init);

  // Diagnostics
  window.__stockBadgeDiag = {
    version: function(){ return window.__STOCK_BADGE_VERSION; },
    classifyNow: async function(){
      var r = root(), p = await getProductData(), v = r && p ? currentVariant(r, p) : null;
      return {
        handle: p && p.handle,
        variantId: v && v.id,
        qty: v && v.inventory_quantity,
        policy: v && v.inventory_policy,
        state: p && v ? stateFor(p, v) : null
      };
    }
  };
})();
